import Image from 'next/image';

interface OptimizedLogoProps {
  color?: 'white' | 'black';
  width?: number;
  height?: number;
  isAdmin?: boolean;
}

export default function OptimizedLogo({
  color = 'black',
  width = 200,
  height = 32,
  isAdmin = false,
}: OptimizedLogoProps) {
  const logoMapping = {
    white:
      'https://innovation-dev-storage.s3.us-east-1.amazonaws.com/logo-white.png',
    black: 'https://innovation-dev-storage.s3.us-east-1.amazonaws.com/logo.png',
  };

  const adminLogoMapping = {
    white:
      'https://innovation-dev-storage.s3.us-east-1.amazonaws.com/admin-logo.png',
    black:
      'https://innovation-dev-storage.s3.us-east-1.amazonaws.com/admin-logo.png',
  };

  const logoSrc = isAdmin ? adminLogoMapping[color] : logoMapping[color];

  return (
    <Image
      src={logoSrc}
      alt="IHQX Logo"
      width={width}
      height={height}
      priority={true} // Mark as LCP element
      loading="eager" // Force eager loading
      sizes={`${width}px`} // Specify exact size needed
      unoptimized={false} // Let Next.js optimize if possible
    />
  );
}
